<div class="bc-workitem-genesys-email-list">
    <div class="bc-sidenav-title-wrapper">
        <h2 class="bc-sidenav-title" data-automation-id="genesys-email-list-title">
          <svg-icon icon="mail"></svg-icon>
          <span class="bc-sidenav-title-label">{{ ( isHybrid ? 'bcWorkItemGenesysEmailList.cxTitleEmails' : 'bcWorkItemGenesysEmailList.titleEmails' ) | translate}}</span>
          <span> ({{ emailConversationCount$ | async }})</span>
        </h2>
        <button class="btn btn-add"
                *gcUserHasAllPermissions="[gcUserPermission.ConversationEmailCreate, gcUserPermission.RoutingQueueSearch]"
                (click)="toggleModal()"
                [attr.aria-label]="'bcWorkitemEmailList.newEmailTooltip' | translate"
                [attr.data-automation-id]="'genesys-email-list-compose-button'">
          <svg-icon icon="plus"></svg-icon>

          <ng2-tooltip direction="right" text="{{ 'bcWorkitemEmailList.newEmailTooltip' | translate }}"></ng2-tooltip>
        </button>
      </div>

      <ul class="bc-workitem-titles-list bc-email-workitems">
        <li class="outer-item" *ngFor="let emailConversation of emailConversations$ | async; trackBy: conversationTrackByFn" [@taskItemAnimation]>
          <app-work-item-genesys-email-list-item
            [conversationId]="emailConversation.id"
            [isOpened]="isOpened(emailConversation.id)"
            [isFocused]="isFocused(emailConversation.id)">
          </app-work-item-genesys-email-list-item>
        </li>
      </ul>
</div>
